export function formDataMapper({ xml, returnUrl, cardId, recurrent, signature, requestId }) {
  return {
    RequestId: requestId,
    PayInfo: xml,
    ReturnUrl: returnUrl,
    CardId: cardId,
    CardRcrMode: recurrent,
    Signature: signature,
  };
}
